import { useState } from "react";

import { Dialog, DialogContent, DialogTitle } from "@mui/material";

import { Translate } from "@/components/Application/Translate";
import FileList from "@/components/Procedures/EditNode/FileList";

import { CloseButton } from "@/helpers/components/CloseButton";

type Props = {
	open: boolean;
	onClose: () => void;
	nodeId: number;
};

const DocumentSearchModal = (props: Props) => {
	const { open, onClose, nodeId } = props;
	const [search, setSearch] = useState("");

	return (
		<Dialog open={open} fullScreen style={{ margin: "3rem" }} onClose={onClose}>
			<DialogTitle>
				<Translate HTMLTag="h2" String="Document.Search.Header">
					Document search
				</Translate>
				<CloseButton onClose={onClose} />
			</DialogTitle>
			<DialogContent>
				<input type="text" onChange={(e) => setSearch(e.target.value)} />
				<FileList onClose={onClose} search={search} nodeId={nodeId} />
			</DialogContent>
		</Dialog>
	);
};

export default DocumentSearchModal;
